var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9321 6.32781C14.0512 6.26167 14.125 6.13619 14.125 6C14.125 5.86381 14.0512 5.73833 13.9321 5.67219L12.2204 4.72122C8.84797 2.84767 5.29293 1.32366 1.61066 0.17295L1.11185 0.017073C0.997989 -0.0185095 0.873988 0.00220653 0.777874 0.0728689C0.68176 0.143531 0.625 0.255709 0.625 0.375003V4.6875C0.625 4.88695 0.781119 5.0515 0.98029 5.06198L1.73752 5.10184C3.58373 5.19901 5.41867 5.44941 7.22341 5.85046L7.40214 5.89018C7.4419 5.89902 7.45913 5.91528 7.46871 5.92818C7.4808 5.94447 7.49024 5.96954 7.49024 6C7.49024 6.03047 7.4808 6.05554 7.46871 6.07182C7.45913 6.08473 7.4419 6.10099 7.40214 6.10982L7.22343 6.14954C5.41868 6.5506 3.58372 6.801 1.7375 6.89817L0.98029 6.93802C0.781119 6.9485 0.625 7.11305 0.625 7.3125V11.625C0.625 11.7443 0.681759 11.8565 0.777874 11.9271C0.873987 11.9978 0.997988 12.0185 1.11185 11.9829L1.61067 11.8271C5.29293 10.6763 8.84797 9.15234 12.2204 7.27879L13.9321 6.32781Z",
    fill: "#D23331"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNext);
export default __webpack_public_path__ + "static/media/ico-next.eeb5dbe34cf68b605f2872b78912823a.svg";
export { ForwardRef as ReactComponent };